import React from 'react';

import { Row, Form } from 'react-bootstrap';
import Select from 'react-select';

import { customStyles } from '../utils';

import './styles.scoped.css';

// PRST-119: @Exception maps to the PointsNorth proc — 'N' = checks generated on/before the
// cutoff (paid before cut off / regular payroll), 'Y' = checks generated after the cutoff
// (paid after cut off / supplemental). The proc has no "all" branch, so there is no A option.
export const exceptionOptions = [
  { label: 'N - Paid Before Cut Off', value: 'N' },
  { label: 'Y - Paid After Cut Off', value: 'Y' },
];

export const PrevailingWageForm = ({ form, setForm, handleChange, errors }) => (
  <div className="filters-container">
    <div className="filter-row" style={{ marginTop: '30px' }}>
      <Form.Group as={Row} controlId="PeriodEndDate" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>
          <div className="required">Period End Date</div>
        </Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="PeriodEndDate"
          value={form?.PeriodEndDate}
          onChange={handleChange}
        />
      </Form.Group>
    </div>
    {errors?.PeriodEndDate && <div className="field-error">{errors.PeriodEndDate}</div>}

    <div className="filter-row">
      <Form.Group as={Row} controlId="CutOffDate" style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>Cut Off Date</Form.Label>
        <Form.Control
          style={{ width: '150px', height: '30px' }}
          as="input"
          type="date"
          name="CutOffDate"
          value={form?.CutOffDate}
          onChange={handleChange}
        />
      </Form.Group>
    </div>

    <div className="filter-row">
      <Form.Group as={Row} style={{ alignItems: 'center' }}>
        <Form.Label style={{ width: '160px' }}>Exception Type</Form.Label>
        <Select
          menuPlacement="auto"
          menuPortalTarget={typeof document === 'undefined' ? null : document.body}
          styles={{
            ...customStyles('365px'),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
          }}
          options={exceptionOptions}
          value={exceptionOptions.find(option => option.value === form?.Exception) || null}
          onChange={selectedOption => setForm({ ...form, Exception: selectedOption?.value || 'N' })}
        />
      </Form.Group>
    </div>
  </div>
);
